import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ConsumerService} from '../../../../recursos/servicio/consumer.service';
import {AuthService} from '../../../../../autenticacion/servicios/auth.service';
import {UtilConfig} from '../../../../../autenticacion/servicios/UtilConfig';
import {Receiver} from '../recursos/modelo/Receiver';
import {WebServices} from '../../../../recursos/modelo/consumerModel/web-services.enum';
import {Emisor} from '../recursos/modelo/emisor';
import {MatSnackBar} from "@angular/material/snack-bar";

declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-nuevo-receptor',
    templateUrl: './view/nuevo-receptor.component.html',
    styleUrls: ['./css/nuevo-receptor.component.scss'],
    providers: [AuthService, ConsumerService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NuevoReceptorComponent implements OnInit {

    @Output() nuevoReceptor = new EventEmitter<Receiver>();
    @Output() cerrarPopup = new EventEmitter<boolean>();
    @Input() saveReceptor = false;
    @Input() docType: any[] = [];
    /**
     * PARAMETROS DE CARGA = LOADING
     *
     */
    loading_popup = false;
    /**
     * FORMULARIOS Y VALIDADORES
     *
     */
    formReceptorNuevo: FormGroup;
    // RECEPTOR NUEVO
    vld_tipoReceptorNuevo: FormControl;
    vld_rucReceptorNuevo: FormControl;
    vld_TelefonoReceptorNuevo: FormControl;
    vld_CorreoReceptorNuevo: FormControl;
    vld_NameReceptorNuevo: FormControl;
    vld_DireccionReceptorNuevo: FormControl;

    /**
     * VARIABLES DE DATA
     *
     */
    popup_text = '';
    tamanoIdDocNumber = '0';
    @Input() receptorNuevo: Receiver = new Receiver();

    constructor(private util: UtilConfig,
                private fb: FormBuilder,
                private cd: ChangeDetectorRef,
                private router: Router,
                private snackBar: MatSnackBar,
                private consumerService: ConsumerService) {
        this.createFormControls();
        this.createFormReceptorNuevo();
    }


    ngOnInit(): void {

        this.adaptarValidacion();
        if(this.receptorNuevo.idDocType == '6' && this.receptorNuevo.idDocNumber.length == 11){
            this.verificarRuc();
        }
    }


    createFormControls() {
        this.vld_tipoReceptorNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_rucReceptorNuevo = new FormControl({value: ''}, [Validators.required, Validators.minLength(11), Validators.maxLength(11)]);
        this.vld_NameReceptorNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_CorreoReceptorNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_TelefonoReceptorNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_DireccionReceptorNuevo = new FormControl({value: ''}, [Validators.nullValidator]);

    }

    createFormReceptorNuevo() {
        this.formReceptorNuevo = this.fb.group({
            'idDocType': this.vld_tipoReceptorNuevo,
            'idDocNumber': this.vld_rucReceptorNuevo,
            'businessName': this.vld_NameReceptorNuevo,
            'email': this.vld_CorreoReceptorNuevo,
            'phone': this.vld_TelefonoReceptorNuevo,
            'address': this.vld_DireccionReceptorNuevo
        });
    }


    adaptarValidacion() {
        if (this.receptorNuevo.idDocType === '0') {
            this.tamanoIdDocNumber = '15';
            this.formReceptorNuevo.controls['idDocNumber'].setValidators([Validators.required,
                 Validators.maxLength(15)]);
            this.formReceptorNuevo.controls['idDocNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator dnd_after');
        }
        if (this.receptorNuevo.idDocType === '1') {
            this.tamanoIdDocNumber = '8';
            this.formReceptorNuevo.controls['idDocNumber']
                .setValidators([Validators.required,
                    Validators.maxLength(8)]);
            this.formReceptorNuevo.controls['idDocNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator dni_after');
        }

        if (this.receptorNuevo.idDocType === '4') {
            this.tamanoIdDocNumber = '15';
            this.formReceptorNuevo.controls['idDocNumber'].setValidators([Validators.required,
                Validators.maxLength(15)]);
            this.formReceptorNuevo.controls['idDocNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator carnetExtrajenria_after');

        }
        if (this.receptorNuevo.idDocType === '6') {
            this.tamanoIdDocNumber = '11';
            this.formReceptorNuevo.controls['idDocNumber'].setValidators([Validators.required,
                Validators.minLength(11), Validators.maxLength(11)]);
            this.formReceptorNuevo.controls['idDocNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator ruc_after');
        }

        if (this.receptorNuevo.idDocType === '7') {
            this.tamanoIdDocNumber = '15';
            this.formReceptorNuevo.controls['idDocNumber'].setValidators([Validators.required,
                Validators.maxLength(15)]);
            this.formReceptorNuevo.controls['idDocNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator pasaporte_after');
        }
        this.cd.markForCheck();
        this.cd.detectChanges();
    }


    onSubmitReceptor() {
        if (this.formReceptorNuevo.valid) {
            this.agregarReceptor();
        } else {
            swal(
                'Campos obligatorios',
                'Debe completar todo los campos con (*)',
                'error'
            );
        }
    }


    agregarReceptor() {
        if (!this.saveReceptor) {
            this.nuevoReceptor.emit(this.receptorNuevo);
            return false;
        }
        const body = {
            receiver: this.receptorNuevo
        };
        this.popup_text = 'Receptor';
        this.loading_popup = true;
        this.consumerService.create(WebServices.URL_ACTUALIZAR_RECEPTORES, body)
            .subscribe(result => {
                if (result['receiver'] != null) {
                    const item = result['receiver'];
                    const receptor = new Receiver();
                    receptor.idDocType = item.idDocType;
                    receptor.idDocNumber = item.idDocNumber;
                    receptor.businessName = item.businessName;
                    receptor.phone = item.phone;
                    receptor.email = item.email;
                    receptor.address = item.address;
                    this.nuevoReceptor.emit(receptor);
                    this.receptorNuevo.businessName = '';
                    this.receptorNuevo.idDocNumber = '';
                    this.receptorNuevo.phone = '';
                    this.receptorNuevo.email = '';
                    this.receptorNuevo.address = '';
                }
                this.loading_popup = false;
                this.snackBar.open('Se ha agregado de forma exitosa el receptor.', null, {duration: 2000});
            }, err => {
                this.loading_popup = false;
                this.util.abrirModalErrorParaServicios(err, 'No se pudo crear el receptor', this.router);
            });
    }

    cerrarPopupReceptor() {
        this.cerrarPopup.emit(true);
    }


    public verificarRuc() {
        if (this.receptorNuevo.idDocNumber !== '') {
            // LLAMADO AL SERVICIO
            this.consumerService.post(WebServices.URL_GET_MASTER_EMISOR, {customer: {ruc: this.receptorNuevo.idDocNumber}})
                .subscribe(result => {
                    const emisor: Emisor = result['customer'];
                    this.receptorNuevo.businessName = emisor.nombre;
                    this.receptorNuevo.email = emisor.correo;
                    const direccion = ((emisor.tipoVia != null) ? emisor.tipoVia : '') + ' ' +
                        ((emisor.nombreVia != null) ? emisor.nombreVia : '') + ' ' +
                        ((emisor.numero != null) ? emisor.numero : '') + ' - ' +
                        ((emisor.interior != null) ? emisor.interior : '') + ',' +
                        ((emisor.codigoZona != null) ? emisor.codigoZona : '') + ' ' +
                        ((emisor.tipoZona != null) ? emisor.tipoZona : '');
                    this.receptorNuevo.address = direccion;
                }, err => {
                    this.util.abrirModalErrorParaServicios(err, 'No se pudo consultar al emisor', this.router);
                });
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-nuevo-receptor/nuevo-receptor.component.ts